import { Outlet, Navigate } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

const PrivateCustomer = () => {
    const [checking, setChecking] = useState(true);
    const [isCustomer, setIsCustomer] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem("user");
        if (!token) {
            setChecking(false);
            setIsCustomer(false);
            return;
        }

        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                setChecking(false);
                if (res.data && res.data.data && res.data.data.isCustomer === true) {
                    setIsCustomer(true);
                } else {
                    setIsCustomer(false);
                }
            })
            .catch(() => {
                setChecking(false);
                setIsCustomer(false);
                localStorage.removeItem("user");
                localStorage.removeItem("profile");
                localStorage.removeItem("data");
            });
    }, []);

    if (checking) {
        return null;
    }

    return isCustomer ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateCustomer;
